<template>
  <div class="student-rank-table">
    <el-table :data="studentList" style="width: 100%" height="calc(100vh - 220px)"
      @selection-change="handleSelectionChange">
      <el-table-column v-if="examType == 'class'" type="selection" width="55">
      </el-table-column>
      <el-table-column prop="className" label="班级"> </el-table-column>
      <el-table-column prop="studentName" label="姓名" width="100"> </el-table-column>
      <el-table-column prop="studentNumber" label="学号" width="150"> </el-table-column>
      <!-- <el-table-column label="科目成绩">
        <template slot-scope="{ row }">
          <div style="max-height: 100px; overflow: auto">
            <el-row v-for="(course, index) in row.courseInfoList" :key="index">
              <el-col :span="8">{{ course.courseName }}</el-col>
              <el-col :span="16">{{ course.score }}</el-col>
            </el-row>
          </div>
        </template>
</el-table-column> -->
      <el-table-column v-for="(item, index) in courseList" :key="index" :label="item.courseName" width="100">
        <template slot-scope="{ row }">
          <span class="score" v-if="
            row.courseInfoList.find(
              (dItem) => dItem.courseName === item.courseName
            )
          ">
            {{
              row.courseInfoList &&
              row.courseInfoList.find(
                (dItem) => dItem.courseName === item.courseName
              ).score
            }}/</span><span class="courseClassRank" v-if="
              row.courseInfoList.find(
                (dItem) => dItem.courseName === item.courseName
              )
            ">{{
              row.courseInfoList &&
              row.courseInfoList.find(
                (dItem) => dItem.courseName === item.courseName
              ).courseClassRank
            }}/</span><span class="courseGradeRank" v-if="
              row.courseInfoList.find(
                (dItem) => dItem.courseName === item.courseName
              )
            ">{{
              row.courseInfoList &&
              row.courseInfoList.find(
                (dItem) => dItem.courseName === item.courseName
              ).courseGradeRank
            }}</span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column prop="avgScore" label="平均分"> </el-table-column>
      <el-table-column prop="totalScore" label="总分"> </el-table-column>
      <el-table-column prop="classRank" label="班级排名"> </el-table-column>
      <el-table-column prop="gradeRank" label="年级排名"> </el-table-column>
      <!-- <el-table-column prop="date" label="年级进步名次"> </el-table-column> -->
      <el-table-column label="操作" width="180px">
        <template slot-scope="{ row }">
          <div class="handle-container">
            <!-- 修改成绩 -->
            <el-button @click="editStudentScore(row)" type="warning" size="small" v-hasPermi="'sc:score:edit'">
              修改成绩
            </el-button>
            <!-- 学生详情 -->
            <el-button @click="jumpStudentDetail(row)" type="success" size="small"
              v-hasPermi="'sc:studentscore:details'">
              详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: [
    "examType",
    "studentList",
    "examInfo",
    "courseList",
    "courseFullList",
  ],
  data() {
    return {};
  },
  methods: {
    // 修改学生成绩
    editStudentScore(row) {
      this.$emit("editStudentScore", row);
    },
    handleSelectionChange(val) {
      let selectList = [];
      val.forEach((item) => {
        selectList.push(item.studentId);
      });
      this.$emit("studentSelect", selectList);
    },
    jumpStudentDetail(row) {
      // console.log(row);
      // 跳转学生成绩详情
      // let { id, title, subTitle } = this.examInfo;
      this.$router.push({
        path: "/achievement-student",
        query: {
          examInfoId: this.examInfo.id, //考试信息id
          studentId: row.studentId,
          courseFullList: this.courseFullList,
          examType: this.examType,
          classId: row.classId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentRankTable.scss";
</style>